import { z } from 'zod';

export type AssignmentsQuery = z.infer<typeof assignmentsQuerySchema>;

export const assignmentsQuerySchema = z.object({
  assigned: z.stringbool().optional(),
  ignored: z.stringbool().optional(),
  parentId: z.uuid().optional(),
  playerId: z.uuid().optional(),
  root: z.stringbool().optional(),
  sessionId: z.uuid().optional(),
});
